<template>
  <UIcon name="light:spinner-third" class="animate-spin text-gray-500" data-element="spinner" />
</template>
